module.exports = __webpack_public_path__ + "resources/img/main02.63d14a80a10c9cce815f88a67250bd53.png";